const isAbsentOrBlank = value => {
  const result = !value || value.trim() === '';
  return result;
};

export default isAbsentOrBlank;
